import { createContext } from 'react';

interface EdgeActionsContextValue {
  deleteEdge: (id: string) => void;
}

export const EdgeActionsContext = createContext<EdgeActionsContextValue>({
  deleteEdge: () => {},
});
